import { gql } from 'graphql-request'

class AppUserQueries {
  getAppUsers = gql`
    query GetAppUsers($where: EndUserWhereInput) {
      endUsers(where: $where) {
        id
        user {
          displayName
          email
        }
        location {
          city
        }
        nbSharedExperiences
        nbPoints
        isSuspended
      }
    }
  `
  getAppUser = gql`
    query GetAppUser($where: EndUserWhereUniqueExtendedInput!) {
      endUser(where: $where) {
        id
        user {
          displayName
          email
        }
        location {
          city
        }
        nbSharedExperiences
        nbPoints
        isSuspended
      }
    }
  `
}

const appUserQueries = new AppUserQueries()

export default appUserQueries
